export const USER_CODE_TYPES = /** @type {const} */ ({
    DEPOSIT: { value: "DEPOSIT", text: "보증금 시스템" },
    RESERVE: { value: "RESERVE", text: "유보금 시스템" },
});
/** @typedef {keyof USER_CODE_TYPES} UserCode_Type */

/** @type {UserCode_Type[]} */
export const Enum_UserCode_Type = Object.keys(USER_CODE_TYPES);
